/**
 * Shown when the zkLogin session can no longer sign (expired / stale proof that
 * auto-recovery couldn't heal). One clear call to action instead of a stack of
 * cryptic red error lines. Purely presentational — the parent owns the
 * `sessionBroken` detection and the reset handler.
 */
interface SessionRecoveryBannerProps {
  onReset: () => void;
}

export function SessionRecoveryBanner({ onReset }: SessionRecoveryBannerProps) {
  return (
    <div
      role="alert"
      className="bg-error pixel-corners p-4 flex items-center justify-between gap-3 flex-wrap"
    >
      <div className="min-w-0">
        <p className="font-heading text-[8px] text-white/90 tracking-[1px] uppercase mb-2">
          SESSION GOT TANGLED
        </p>
        <p className="font-grotesk font-medium text-[13px] text-white">
          Your login expired or the proof went stale. Reconnect to keep stamping.
        </p>
      </div>
      <button
        type="button"
        onClick={onReset}
        className="flex-none pixel-corners-sm bg-white text-primary font-grotesk font-bold text-[13px] py-[11px] px-4"
      >
        Reset
      </button>
    </div>
  );
}

export default SessionRecoveryBanner;
